<template>
  <div class="container-fluid">
    <Content></Content>
  </div>
</template>

<script>
// @ts-nocheck
import Content from "./components/Content";
export default {
  components: {
    Content
  },
  methods:{
     openLoading() {
          const loading = this.$vs.loading({
            type:'points',
            background: "#000",
            color: '#fff',
          })
          setTimeout(() => {
            loading.close()
          }, 2000)
        }
  },
  created(){
    this.openLoading();
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Sansita+Swashed:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cabin:wght@400;500&display=swap');
html {
  scroll-behavior: smooth;
}
* {
  box-sizing: border-box;
}
body {
  background: #ecf0f1;
  margin: 0;
  padding: 0;
 font-family: 'Sansita Swashed', cursive;
}
.container-fluid {
  padding: 0 !important;
  overflow-x: hidden;
}
h1{
   font-family: 'Sansita Swashed', cursive;
   font-size:45px;
}
</style>
